import WilayahApi from './WilayahApi'

export default WilayahApi